module.exports = __webpack_public_path__ + "static/media/peace.35bc71db.webp";